import { Index, Lens, Optional, Prism } from 'monocle-ts';
const makeMonocleFor = () => ({
    lensFromProp: Lens.fromProp(),
    lensFromProps: Lens.fromProps(),
    lensFromPath: Lens.fromPath(),
    indexFromAt: Index.fromAt,
    optionalFromOptionProp: Optional.fromOptionProp(),
    optionalFromNullableProp: Optional.fromNullableProp(),
    prism: Prism.some(),
    prismFromPredicate: Prism.fromPredicate
});
const staticMonocle = makeMonocleFor();
/**
 *  @since 0.0.1
 */
export const MonocleFor = () => staticMonocle;
